import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@app/material/material.module';
import { CheckboxModule } from '@shared/components/form/checkbox/checkbox.module';
import { SelectModule } from '@shared/components/form/select/select.module';
import { InputModule } from '@shared/components/form/input/input.module';
import { ButtonModule } from '@shared/components/button/button.module';

import { QuestionDialogComponent } from './question-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    SelectModule,
    CheckboxModule,
    InputModule,
    ButtonModule
  ],
  declarations: [QuestionDialogComponent],
  entryComponents: [QuestionDialogComponent],
  exports: [QuestionDialogComponent]
})
export class QuestionDialogModule { }
